<section class="official__documents">
    <div class="official__documents__content px-md-4 px-2 pb-4">
        <div>
            <form
                [formGroup]="officialDocumentsForm"
                (ngSubmit)="onSubmit()"
                class="official__documents__content__container"
            >
                <div
                    class="official__documents__content__container__choose px-md-4 px-2 d-flex flex-column"
                >
                    <span
                        class="official__documents__content__container__choose__title mb-1 mt-4"
                        >{{
                            'fe_precheckin_official_documents_content_container_choose_title'
                                | translate
                        }}</span
                    >
                    <span
                        class="official__documents__content__container__choose__subtitle mb-2"
                        >{{
                            'fe_precheckin_official_documents_content_container_choose_subtitle'
                                | translate
                        }}</span
                    >
                    <div
                        class="official__documents__content__container__choose__radio d-flex flex-column flex-sm-row justify-content-left px-md-1 px-2 mb-3"
                    >
                        <div class="d-flex flex-row">
                            <input
                                class="mb-sm-0 mb-3"
                                type="radio"
                                name="documentId"
                                id="id"
                                value="INE"
                                formControlName="documentId"
                                autocomplete="off"
                            />
                            <label for="id" class="px-3">{{
                                'fe_precheckin_official_documents_content_container_choose_radio_id'
                                    | translate
                            }}</label>
                        </div>
                        <div class="d-flex flex-row">
                            <input
                                class="ps-2"
                                type="radio"
                                name="documentId"
                                id="passport"
                                value="PASSPORT"
                                formControlName="documentId"
                                autocomplete="off"
                            />
                            <label for="passport" class="px-3">{{
                                'fe_precheckin_official_documents_content_container_choose_radio_passport'
                                    | translate
                            }}</label>
                        </div>
                    </div>
                </div>
                <div
                    class="official__documents__content__container__id px-md-4 px-2"
                >
                    <img
                        class="mb-2"
                        [src]="
                            officialDocumentsForm.get('documentId')?.value ===
                            'PASSPORT'
                                ? ('images/pasaporte.jpg' | cdn)
                                : ('images/cic_ine.png' | cdn)
                        "
                        [alt]="
                            officialDocumentsForm.get('documentId')?.value ===
                            'PASSPORT'
                                ? 'Passport example'
                                : 'ID example'
                        "
                    />
                    <div class="col-12 col-md-6">
                        <span
                            class="official__documents__content__container__id__title"
                            >{{
                                isPassportSelected
                                    ? ('fe_precheckin_official_documents_content_container_choose_radio_passport'
                                      | translate)
                                    : ('fe_precheckin_official_documents_content_container_choose_radio_id'
                                      | translate)
                            }}</span
                        >
                        <fe-input
                            class="mb-3 mt-2"
                            [id]="'idNumber'"
                            [label]="
                                isPassportSelected
                                    ? ('fe_precheckin_official_documents_content_container_id_idnumber_passport'
                                      | translate)
                                    : ('fe_precheckin_official_documents_content_container_id_idnumber_id'
                                      | translate)
                            "
                            [tabIndex]="'1001'"
                            formControlName="idNumber"
                        ></fe-input>
                    </div>
                    <div class="col-12 col-md-6">
                        <fe-input
                            class="mb-2"
                            [id]="'idExpirationDate'"
                            [label]="
                                'fe_precheckin_official_documents_content_container_id_idexpirationdate'
                                    | translate
                            "
                            [formatDate]="inputDatePickerFormat"
                            [isDatepicker]="true"
                            [isSingleDatepicker]="true"
                            [min]="returnDate"
                            [isExpiration]="true"
                            [mask]="'00/00/0000'"
                            [tabIndex]="'1002'"
                            formControlName="idExpirationDate"
                        ></fe-input>
                    </div>
                    <span
                        class="official__documents__content__container__id__legend"
                        >{{
                            'fe_precheckin_official_documents_content_container_id_legend'
                                | translate
                        }}</span
                    >
                </div>
                <div
                    class="official__documents__content__container__driver px-md-4 px-2 d-flex flex-column"
                >
                    <span
                        class="official__documents__content__container__driver__title mt-4 mb-1"
                        >{{
                            'fe_precheckin_official_documents_content_container_driver_title'
                                | translate
                        }}</span
                    >
                    <span
                        class="official__documents__content__container__driver__subtitle mb-3"
                        >{{
                            'fe_precheckin_official_documents_content_container_driver_subtitle'
                                | translate
                        }}</span
                    >
                    <div class="col-12 col-md-6">
                        <fe-input
                            class="mb-3"
                            [id]="'driverNumber'"
                            [label]="
                                'fe_precheckin_official_documents_content_container_driver_drivernumber'
                                    | translate
                            "
                            [tabIndex]="'1003'"
                            formControlName="driverNumber"
                        ></fe-input>
                    </div>
                    <div class="col-12 col-md-6">
                        <fe-input
                            class="mb-3"
                            [id]="'driverCountry'"
                            [isSelect]="true"
                            [selectType]="'typing'"
                            [loading]="loadingCountries"
                            [items]="addressService.countries"
                            [label]="
                                'fe_precheckin_official_documents_content_container_driver_drivercountry'
                                    | translate
                            "
                            [tabIndex]="'1004'"
                            [formControlName]="'driverCountry'"
                            (change)="onChangeCountry()"
                        ></fe-input>
                    </div>
                    <div class="col-12 col-md-6">
                        <fe-input
                            *ngIf="statesForOfficialDocuments.length === 0"
                            class="mb-3"
                            [id]="'driverEmissionState'"
                            [loading]="loadingStates"
                            [label]="
                                'fe_precheckin_official_documents_content_container_driver_driveremissionstate'
                                    | translate
                            "
                            [tabIndex]="'1005'"
                            [formControlName]="'driverEmissionState'"
                        ></fe-input>
                        <fe-input
                            *ngIf="statesForOfficialDocuments.length > 0"
                            class="mb-3"
                            [id]="'driverEmissionState'"
                            [isSelect]="true"
                            [selectType]="'typing'"
                            [loading]="loadingStates"
                            [items]="statesForOfficialDocuments"
                            [label]="
                                'fe_precheckin_official_documents_content_container_driver_driveremissionstate'
                                    | translate
                            "
                            [tabIndex]="'1005'"
                            [formControlName]="'driverEmissionState'"
                        ></fe-input>
                    </div>
                    <div class="col-12 col-md-6">
                        <fe-input
                            class="mb-3"
                            [id]="'driverExpirationDate'"
                            [label]="
                                'fe_precheckin_official_documents_content_container_driver_driverexpirationdate'
                                    | translate
                            "
                            [formatDate]="inputDatePickerFormat"
                            [isDatepicker]="true"
                            [isSingleDatepicker]="true"
                            [min]="returnDate"
                            [isExpiration]="true"
                            [mask]="'00/00/0000'"
                            [tabIndex]="'1006'"
                            formControlName="driverExpirationDate"
                        ></fe-input>
                    </div>
                    <div class="col-12 col-md-6">
                        <fe-input
                            [id]="'driverEmissionDate'"
                            [label]="
                                'fe_precheckin_official_documents_content_container_driver_driveremissiondate'
                                    | translate
                            "
                            [formatDate]="inputDatePickerFormat"
                            [isDatepicker]="true"
                            [isSingleDatepicker]="true"
                            [max]="today"
                            [isEmission]="true"
                            [mask]="'00/00/0000'"
                            [tabIndex]="'1007'"
                            formControlName="driverEmissionDate"
                        ></fe-input>
                    </div>
                </div>
            </form>
            <form
                *ngIf="additionalDriver"
                [formGroup]="additionalDriverForm"
                (ngSubmit)="onSubmit()"
                class="official__documents__content__container mt-4"
                style="border-top: 1px solid #c9ccd4"
            >
                <div
                    class="official__documents__content__container__choose px-md-4 px-2 d-flex flex-column"
                >
                    <span
                        class="official__documents__content__container__choose__title mb-1 mt-4"
                        >{{
                            'fe_precheckin_official_documents_content_container_choose_title_additional'
                                | translate
                        }}</span
                    >
                    <span
                        class="official__documents__content__container__choose__subtitle mb-2"
                        >{{
                            'fe_precheckin_official_documents_content_container_choose_subtitle'
                                | translate
                        }}</span
                    >
                    <div
                        class="official__documents__content__container__choose__radio d-flex flex-column flex-sm-row justify-content-left px-md-1 px-2 mb-3"
                    >
                        <div class="d-flex flex-row">
                            <input
                                class="mb-sm-0 mb-3"
                                type="radio"
                                name="documentId2"
                                id="id2"
                                value="INE"
                                formControlName="documentId2"
                            />
                            <label for="id2" class="px-3">{{
                                'fe_precheckin_official_documents_content_container_choose_radio_id'
                                    | translate
                            }}</label>
                        </div>
                        <div class="d-flex flex-row">
                            <input
                                class="ps-2"
                                type="radio"
                                name="documentId2"
                                id="passport2"
                                value="PASSPORT"
                                formControlName="documentId2"
                            />
                            <label for="passport2" class="px-3">{{
                                'fe_precheckin_official_documents_content_container_choose_radio_passport'
                                    | translate
                            }}</label>
                        </div>
                    </div>
                </div>
                <div
                    class="official__documents__content__container__id px-md-4 px-2"
                >
                    <img
                        class="mb-2"
                        [src]="
                            additionalDriverForm.get('documentId2')?.value ===
                            'PASSPORT'
                                ? ('images/pasaporte.jpg' | cdn)
                                : ('images/cic_ine.png' | cdn)
                        "
                        [alt]="
                            additionalDriverForm.get('documentId2')?.value ===
                            'PASSPORT'
                                ? 'Passport example'
                                : 'ID example'
                        "
                    />
                    <div class="col-12 col-md-6">
                        <span
                            class="official__documents__content__container__id__title"
                        >
                            {{
                                isPassportSelected2
                                    ? ('fe_precheckin_official_documents_content_container_choose_radio_passport'
                                      | translate)
                                    : ('fe_precheckin_official_documents_content_container_choose_radio_id'
                                      | translate)
                            }}*
                        </span>
                        <fe-input
                            class="mb-3 mt-2"
                            [id]="'idNumber2'"
                            [label]="
                                isPassportSelected2
                                    ? ('fe_precheckin_official_documents_content_container_id_idnumber_passport'
                                      | translate)
                                    : ('fe_precheckin_official_documents_content_container_id_idnumber_id'
                                      | translate)
                            "
                            [tabIndex]="'1008'"
                            formControlName="idNumber2"
                        ></fe-input>
                    </div>
                    <div class="col-12 col-md-6">
                        <fe-input
                            class="mb-2"
                            [id]="'idExpirationDate2'"
                            [label]="'Fecha de vencimiento (dd/mm/aaaa)*'"
                            [formatDate]="inputDatePickerFormat"
                            [isDatepicker]="true"
                            [isSingleDatepicker]="true"
                            [min]="returnDate"
                            [isExpiration]="true"
                            [mask]="'00/00/0000'"
                            [tabIndex]="'1009'"
                            formControlName="idExpirationDate2"
                        ></fe-input>
                    </div>
                    <span
                        class="official__documents__content__container__id__legend"
                        >{{
                            'fe_precheckin_official_documents_content_container_id_legend'
                                | translate
                        }}
                    </span>
                </div>
                <div
                    class="official__documents__content__container__driver px-md-4 px-2 d-flex flex-column"
                >
                    <span
                        class="official__documents__content__container__driver__title mt-4 mb-1"
                        >{{
                            'fe_precheckin_official_documents_content_container_driver_title'
                                | translate
                        }}</span
                    >
                    <span
                        class="official__documents__content__container__driver__subtitle mb-3"
                        >{{
                            'fe_precheckin_official_documents_content_container_driver_subtitle'
                                | translate
                        }}
                    </span>
                    <div class="col-12 col-md-6">
                        <fe-input
                            class="mb-3"
                            [id]="'driverNumber2'"
                            [label]="
                                'fe_precheckin_official_documents_content_container_driver_drivernumber'
                                    | translate
                            "
                            [tabIndex]="'1010'"
                            formControlName="driverNumber2"
                        ></fe-input>
                    </div>
                    <div class="col-12 col-md-6">
                        <fe-input
                            class="mb-3"
                            [id]="'driverCountry2'"
                            [isSelect]="true"
                            [selectType]="'typing'"
                            [loading]="loadingCountries"
                            [items]="addressService.countries"
                            [label]="
                                'fe_precheckin_official_documents_content_container_driver_drivercountry'
                                    | translate
                            "
                            [tabIndex]="'1011'"
                            formControlName="driverCountry2"
                            (change)="onChangeCountry2()"
                        ></fe-input>
                    </div>
                    <div class="col-12 col-md-6">
                        <fe-input
                            *ngIf="statesForAdditionalDriver.length === 0"
                            class="mb-3"
                            [id]="'driverEmissionState2'"
                            [loading]="loadingStates2"
                            [label]="
                                'fe_precheckin_official_documents_content_container_driver_driveremissionstate'
                                    | translate
                            "
                            [tabIndex]="'1012'"
                            formControlName="driverEmissionState2"
                        ></fe-input>
                        <fe-input
                            *ngIf="statesForAdditionalDriver.length > 0"
                            class="mb-3"
                            [id]="'driverEmissionState2'"
                            [isSelect]="true"
                            [selectType]="'typing'"
                            [loading]="loadingStates2"
                            [items]="statesForAdditionalDriver"
                            [label]="
                                'fe_precheckin_official_documents_content_container_driver_driveremissionstate'
                                    | translate
                            "
                            [tabIndex]="'1012'"
                            formControlName="driverEmissionState2"
                        ></fe-input>
                    </div>
                    <div class="col-12 col-md-6">
                        <fe-input
                            class="mb-3"
                            [id]="'driverExpirationDate2'"
                            [label]="
                                'fe_precheckin_official_documents_content_container_driver_driverexpirationdate'
                                    | translate
                            "
                            [formatDate]="inputDatePickerFormat"
                            [isDatepicker]="true"
                            [isSingleDatepicker]="true"
                            [min]="returnDate"
                            [isExpiration]="true"
                            [mask]="'00/00/0000'"
                            [tabIndex]="'1013'"
                            formControlName="driverExpirationDate2"
                        ></fe-input>
                    </div>
                    <div class="col-12 col-md-6">
                        <fe-input
                            class="mb-3"
                            [id]="'driverEmissionDate2'"
                            [label]="
                                'fe_precheckin_official_documents_content_container_driver_driveremissiondate'
                                    | translate
                            "
                            [formatDate]="inputDatePickerFormat"
                            [isDatepicker]="true"
                            [isSingleDatepicker]="true"
                            [max]="today"
                            [isEmission]="true"
                            [mask]="'00/00/0000'"
                            [tabIndex]="'1014'"
                            formControlName="driverEmissionDate2"
                        ></fe-input>
                    </div>
                </div>
            </form>
            <div
                class="official__documents__content__container__check px-md-4 px-2 d-flex align-items-center"
            >
                <input
                    class="ms-1 me-3"
                    id="confirmCheckbox"
                    type="checkbox"
                    [(ngModel)]="isCheckboxChecked"
                    (change)="onCheckboxChange()"
                />
                <label for="confirmCheckbox">
                    {{
                        'fe_precheckin_official_documents_content_container_check_label'
                            | translate
                    }}
                    <a
                        [routerLink]="
                            'questions/car-rental-conditions-and-policies'
                                | formatUrl
                        "
                        target="_blank"
                        >{{
                            'fe_precheckin_official_documents_content_container_check_first_a'
                                | translate
                        }}</a
                    >,
                    <a
                        [routerLink]="
                            'questions/car-rental-conditions-and-policies'
                                | formatUrl
                        "
                        fragment="garantia"
                        target="_blank"
                        >{{
                            'fe_precheckin_official_documents_content_container_check_second_a'
                                | translate
                        }}</a
                    >,
                    <a
                        [routerLink]="'questions/refunds-policy' | formatUrl"
                        target="_blank"
                        >{{
                            'fe_precheckin_official_documents_content_container_check_third_a'
                                | translate
                        }}</a
                    >
                </label>
            </div>
            <div
                *ngIf="showCheckboxError"
                class="official__documents__content__container__check__error text-danger mt-1 px-md-4 px-2"
            >
                {{
                    'fe_precheckin_official_documents_content_checkbox_error'
                        | translate
                }}
            </div>
        </div>
    </div>
</section>
